/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

import { FORM_FIELD } from './constants';

const Item = ({ className, module, errors }) => {
  const { media } = useMedia(getImage(module.content));

  return (
    <InfoItem.WithError
      error={errors}
      className={className}
      size="large"
      image={media.src}
      description={module.content[FORM_FIELD.EVENT_TITLE.name]}
    >
      Past Event Result
    </InfoItem.WithError>
  );
};

export default Item;
